import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { Logger } from '../utils/logger';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import * as THREE from 'three';

export { loadScene, loadRgbeTexture, loadTexture };

function loadScene(pathToScene) {
    const loader = new GLTFLoader();
    return new Promise((resolve, reject) => {
        loader.load(
            pathToScene,
            (gltf) => {
                Logger.info('Scene loaded');
                resolve(gltf.scene);
            },
            undefined,
            (error) => reject(error)
        );
    });
}

async function loadRgbeTexture(pathToMapFile, { basePath } = {}) {
    const loader = new RGBELoader().setDataType(THREE.UnsignedByteType);
    basePath && loader.setPath(basePath);
    return await loader.loadAsync(pathToMapFile);
}

async function loadTexture(pathToTexture, { basePath } = {}) {
    const loader = new THREE.TextureLoader();
    basePath && loader.setPath(basePath);
    return await loader.loadAsync(pathToTexture);
}
